/*
 * @Description:
 * @Author: muqingkun
 * @Date: 2023-07-27 16:37:31
 * @LastEditTime: 2023-08-09 09:55:06
 * @LastEditors: muqingkun
 * @Reference:
 */
import { DefineComponent } from 'vue';
export default function (app: {
  component: (name: string, component: globalThis.Component) => void;
}) {
  const modules: Record<string, { default: DefineComponent }> =
    import.meta.glob(['./BaseComponents/*.vue'], { eager: true });
  /*
   * 批量引入组件
   * */
  for (const i in modules) {
    const name = /(.*)?\/(.*).vue/.exec(i);
    app.component('Yl' + name[2], modules[i].default);
  }
}
